import { Editor } from "primereact/editor"
import styled from "styled-components"

export const StyledTextEditor = styled(Editor)``
